import * as React from 'react';
const PiediSecchiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="m110.58 86.11 5.39-6.29 5.4 1.8v4.49l2.7 3.6-1.8 5.4-6.3-2.7-4.5.9.9-3.6zM106.98 97.02l.9-.11 3.59-3.6M110.58 86.11l-4.5-3.59h-1.8l-.9.72"
      className="prefix__cls-1"
    />
    <path
      d="m103.38 79.1 3.6-2.88 8.09.9.9 2.7M116.87 63.63l-3.6 6.29 1.8 7.2M121.37 81.62l2.7-2.7.9-2.7-.9-2.7-.9-8.1M106.98 76.22l-.9-4.5 7.19-1.8"
      className="prefix__cls-1"
    />
    <path
      d="m131.26 74.42-2.69 1.8h-3.6M124.07 89.71l8.99-7.19M122.27 95.11l3.6 2.7"
      className="prefix__cls-1"
    />
    <path
      d="M116.87 101.98c9.21-1.69 16.19-9.76 16.19-19.46 0-10.93-8.86-19.79-19.79-19.79-4.55 0-8.75 1.54-12.09 4.12"
      className="prefix__cls-1"
    />
    <path
      d="M66.42 72.02s1.52 11.66 1.52 17.02-5.71 21.22-5.71 27.75 4.2 11.19 11.19 11.19c8.51 0 14.81-2.8 19.59-2.8 8.05 0 13.06 2.8 20.99 2.8 5.71 0 8.4-1.4 9.79-1.4s3.73 1.4 7 1.4c2.93 0 7-1.34 7-6.32 0-.52-.2-1.04-.53-1.45s-.8-.72-1.33-.72c-10.74 0-19.65-8.82-24.73-11.09-8.33-3.73-18.19-8.33-18.19-13.99V72.02"
      className="prefix__cls-2"
    />
    <path
      d="M74.81 98.6c-1.38 3.08-.05 6.59 2.8 8.4"
      className="prefix__cls-2"
    />
  </svg>
);
export default PiediSecchiIcon;
